"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nth = void 0;
const rightStr_1 = __importDefault(require("@opsbase/lib-general/utils/rightStr"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function nth(d) {
    const zeroD = (0, rightStr_1.default)(`0${d}`, 2);
    return (0, moment_timezone_1.default)(`2020-01-${zeroD}T12:00:00Z`).format('Do');
}
exports.nth = nth;
